export const products = [
  {
    id: 'db',
    guid: 1,
    title: 'Defined Benefit (DB)',
    shortTitle: 'DB',
    reports: [],
  },
  {
    id: 'dc',
    guid: 2,
    title: 'Defined Contribution (DC)',
    shortTitle: 'DC',
    reports: [],
  },
  {
    id: 'pa',
    guid: 3,
    title: 'Pension Administration (PABS)',
    shortTitle: 'PABS',
    reports: [],
  },
]
